import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import CssBaseline from '@mui/material/CssBaseline'
import { ThemeProvider } from '@mui/material/styles'
import { App } from './App'
import { store } from './store'
import { theme } from './theme'

const container = document.getElementById('root')
if (!container) throw new Error('No #root element to mount into.')

createRoot(container).render(
  <StrictMode>
    <Provider store={store}>
      {/* `system` unless the reader has said otherwise, and their
          answer is remembered under MUI's own storage key. `noSsr`
          because nothing here is server-rendered: without it the first
          paint is the default mode and the second is the real one,
          which is a flash of the wrong scheme on every load. */}
      <ThemeProvider theme={theme} defaultMode="system" noSsr>
        <CssBaseline />
        {/* Opted in now rather than at the v7 upgrade: both change how
            navigation resolves, and meeting them for the first time
            alongside everything else a major version moves is how a
            routing change gets misread as an application bug. */}
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  </StrictMode>,
)
